import { useEffect } from "react";

const SITE_URL = "https://belorentals.com";
const DEFAULT_IMAGE = `${SITE_URL}/belo-og.png`;

function upsertMeta(attr, key, content) {
  if (content === undefined || content === null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Dependency-free document-head manager for per-route SEO (title, meta, canonical, JSON-LD).
export function Seo({ title, description, path = "", keywords, image, type = "website", jsonLd, alternates, noindex = false }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : null;
  const altKey = alternates ? JSON.stringify(alternates) : null;
  useEffect(() => {
    const url = `${SITE_URL}${path}`;
    const img = image || DEFAULT_IMAGE;
    if (title) document.title = title;
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);

    upsertMeta("property", "og:site_name", "Belo Rentals");
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", img);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", img);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    // Reciprocal hreflang alternates (e.g. en-US / pt-BR / x-default)
    const altEls = [];
    document.head.querySelectorAll('link[rel="alternate"][data-seo-alt]').forEach((n) => n.remove());
    if (alternates) {
      alternates.forEach(({ lang, path: p }) => {
        const link = document.createElement("link");
        link.setAttribute("rel", "alternate");
        link.setAttribute("hreflang", lang);
        link.setAttribute("href", `${SITE_URL}${p}`);
        link.setAttribute("data-seo-alt", "1");
        document.head.appendChild(link);
        altEls.push(link);
      });
    }

    let script;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "route");
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
      altEls.forEach((n) => n.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, keywords, image, type, ld, altKey, noindex]);

  return null;
}
